import Request from '../utils/request'

export function getDiseaseCategoryByNameApi (params) {
  return Request({
    url: '/follow/diseaseCategory/list',
    method: 'get',
    params
  })
}

export function getDiseaseCategoryApi () {
  return Request({
    url: '/follow/disease/category/standard/list',
    method: 'get'
  })
}

export function getPatientCustomizeGuaranteePlanPageApi (params) {
  return Request({
    url: '/follow/patientCustomizeGuaranteePlan/page',
    method: 'get',
    params
  })
}
